import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../supabaseClient';
import { fetchUserGroups } from '../../lib/proximity/runtime';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

export function useFindGroups(userId, { authReady = true } = {}) {
  return useQuery({
    queryKey: queryKeys.find.groups(userId),
    queryFn: () => fetchUserGroups(supabase, userId),
    enabled: Boolean(userId) && authReady,
    staleTime: STALE.user,
    select: (data) => data ?? [],
  });
}
